import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceHero from '../components/ServiceHero';
import ServiceFeatures from '../components/ServiceFeatures';
import ServiceDetails from '../components/ServiceDetails';
import ServiceCTA from '../components/ServiceCTA';
import { useTranslation } from 'react-i18next';

export default function ConsultingPage() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-lightbulb-flash-line', title: t('servicePages.consulting.features.f1.title'), desc: t('servicePages.consulting.features.f1.desc') },
    { icon: 'ri-bar-chart-box-line', title: t('servicePages.consulting.features.f2.title'), desc: t('servicePages.consulting.features.f2.desc') },
    { icon: 'ri-search-eye-line', title: t('servicePages.consulting.features.f3.title'), desc: t('servicePages.consulting.features.f3.desc') },
    { icon: 'ri-file-chart-line', title: t('servicePages.consulting.features.f4.title'), desc: t('servicePages.consulting.features.f4.desc') },
    { icon: 'ri-focus-3-line', title: t('servicePages.consulting.features.f5.title'), desc: t('servicePages.consulting.features.f5.desc') },
    { icon: 'ri-award-line', title: t('servicePages.consulting.features.f6.title'), desc: t('servicePages.consulting.features.f6.desc') },
  ];

  const details = [
    {
      label: t('servicePages.consulting.details.d1.label'),
      title: t('servicePages.consulting.details.d1.title'),
      body: t('servicePages.consulting.details.d1.body'),
      image: 'https://public.readdy.ai/ai/img_res/ea56b9e9e4500b29c33e3b9494d61ccb.jpg',
      reverse: false,
    },
    {
      label: t('servicePages.consulting.details.d2.label'),
      title: t('servicePages.consulting.details.d2.title'),
      body: t('servicePages.consulting.details.d2.body'),
      image: 'https://readdy.ai/api/search-image?query=abstract%20expert%20opinion%20and%20analysis%20concept%20with%20glowing%20documents%20and%20magnifying%20glass%20on%20dark%20background%2C%20cyan%20neon%20light%20accents%2C%20professional%20audit%20and%20evaluation%20atmosphere%2C%20deep%20navy%20graphite%20tones%2C%20no%20people%2C%20cinematic%20lighting%2C%20minimalist%20high%20tech%20aesthetic&width=800&height=500&seq=consulting-detail-02&orientation=landscape',
      reverse: true,
    },
  ];

  return (
    <div className="min-h-screen bg-[#0f1419]">
      <Header />
      <main>
        <ServiceHero
          icon="ri-lightbulb-line"
          label={t('servicePages.consulting.label')}
          title={t('servicePages.consulting.title')}
          subtitle={t('servicePages.consulting.subtitle')}
          bgImage="https://readdy.ai/api/search-image?query=dark%20futuristic%20consulting%20and%20strategy%20background%20with%20glowing%20abstract%20data%20nodes%20and%20analytical%20charts%2C%20deep%20navy%20graphite%20atmosphere%2C%20professional%20expert%20advisory%20concept%2C%20ultra%20wide%20panoramic%2C%20cinematic%20dark%20moody%20lighting%2C%20subtle%20neon%20cyan%20accents%2C%20no%20people&width=1920&height=900&seq=consulting-hero-bg-001&orientation=landscape"
        />
        <ServiceFeatures features={features} />
        <ServiceDetails details={details} />
        <ServiceCTA />
      </main>
      <Footer />
    </div>
  );
}
